import { render, staticRenderFns } from "./s1-5.vue?vue&type=template&id=ec4481be&scoped=true&"
import script from "./s1-5.vue?vue&type=script&lang=js&"
export * from "./s1-5.vue?vue&type=script&lang=js&"
import style0 from "./s1-5.vue?vue&type=style&index=0&id=ec4481be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec4481be",
  null
  
)

export default component.exports